import OrderJobAssigneeModel from "@/models/OrderJobAssigneeModel";

export default class OrderJobAssigneeViewModel extends OrderJobAssigneeModel {
	constructor(data?: any) {
        super(data);
		if (data) {
            this.isAssigneeSelected = data.isAssigneeSelected ?? false;
			this.isTimeRangeEditMode = data.isTimeRangeEditMode ?? false;
			this.isDateEditMode = data.isDateEditMode ?? false;
		}
	}

    isAssigneeSelected = false;
	isTimeRangeEditMode = false;
	isDateEditMode = false;
}